var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticClass:"form-input",attrs:{"id":_vm.id,"name":_vm.name,"type":"time"},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }